module.exports = __webpack_public_path__ + "static/media/test20_1.7cce760f.png";